import { useEffect, useMemo } from 'react';
import { GridApi, GridOptions } from 'ag-grid-community';
import { Row, UseControlledAGGridProps } from '../types';
import { toProcessDataFromClipboard } from '../clipboard';

export const useClipboard = <
  RowData,
  FullWidthRowData = never,
  RowId extends string = string,
>(
  props: UseControlledAGGridProps<RowData, FullWidthRowData, RowId>,
  api: GridApi | null
) => {
  const processDataFromClipboard = useMemo(
    () =>
      props.processDataFromClipboard
        ? toProcessDataFromClipboard<RowData, RowId>(
            props.processDataFromClipboard
          )
        : undefined,
    [props.processDataFromClipboard]
  );

  useEffect(() => {
    if (!api || !processDataFromClipboard) {
      return;
    }

    api.updateGridOptions({
      processDataFromClipboard,
    });
  }, [api, processDataFromClipboard]);

  // AG Grid's rowDragEntireRow requires cellSelection to be unset.
  const clipboardProps: GridOptions<Row<RowData, RowId>> = {
    cellSelection: props.dragAndDroppable?.dragEntireRow ? undefined : true,
    processDataFromClipboard,
  };

  return { clipboardProps };
};
